export const tableHeaders: string[] = [
  'Rate Card; MRC',
  'Rate Card; NRC',
  'Solution; MRC',
  'Solution; NRC',
];
